var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import TextField from '../../../uikit/inputs/TextField';
import { noop } from '../../../utils/noop';
import { MaskedInput } from './MaskedInput';
export var TextInput = function (props) {
    var _a = props.onChange, onChange = _a === void 0 ? noop : _a, _b = props.onBlur, onBlur = _b === void 0 ? noop : _b, _c = props.onFocus, onFocus = _c === void 0 ? noop : _c, transform = props.transform, transformOnChange = props.transformOnChange, error = props.error, value = props.value, restProps = __rest(props, ["onChange", "onBlur", "onFocus", "transform", "transformOnChange", "error", "value"]);
    var handleChange = useCallback(function (e) {
        var value = e.target.value;
        var nextValue = typeof transformOnChange === 'function'
            ? transformOnChange(value)
            : value;
        onChange(nextValue, e);
    }, [onChange]);
    var handleBlur = useCallback(function (e) {
        var value = e.target.value;
        var nextValue = typeof transform === 'function' ? transform(value) : value;
        if (nextValue !== value) {
            e.target.value = nextValue;
        }
        onBlur(nextValue, e);
    }, [onBlur]);
    var preparedProps = {
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: onFocus,
        error: !!error,
        value: value ? String(value) : undefined,
    };
    return 'mask' in props ? (React.createElement(MaskedInput, __assign({}, restProps, { mask: props['mask'], keepCharPositions: props['keepCharPositions'], placeholderChar: props['placeholderChar'] }, preparedProps))) : (React.createElement(TextField, __assign({}, restProps, preparedProps)));
};
